var menu = "https://shopfront-cdn.tekoapis.com/static/789d831c0ec23c90.svg";

export { menu as default };
